import React from "react";
import { FiGrid, FiMap } from "react-icons/fi";
import { useLanguage } from "../../i18n";
import "./HomeViewToggle.css";

export default function HomeViewToggle({ viewMode = "grid", onViewModeChange }) {
  const { t } = useLanguage();

  return (
    <div className="home-view-toggle" role="group" aria-label={t("home.viewModeLabel")}>
      <button
        type="button"
        className={`home-view-toggle__btn${viewMode === "map" ? " home-view-toggle__btn--active" : ""}`}
        onClick={() => onViewModeChange?.("map")}
        aria-label={t("home.mapView")}
        aria-pressed={viewMode === "map"}
      >
        <FiMap aria-hidden />
      </button>
      <button
        type="button"
        className={`home-view-toggle__btn${viewMode === "grid" ? " home-view-toggle__btn--active" : ""}`}
        onClick={() => onViewModeChange?.("grid")}
        aria-label={t("home.gridView")}
        aria-pressed={viewMode === "grid"}
      >
        <FiGrid aria-hidden />
      </button>
    </div>
  );
}
